import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    paddingLeft: '10px',
    paddingRight: '10px',
    margin: '0 auto',
  },
  title: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: '3.125rem',
    paddingTop: '20px',
    paddingBottom: '20px',
    [theme.breakpoints.up('md')]: {
      fontSize: '40px',
      paddingTop: '50px',
      paddingBottom: '40px',
    },
  },
  testimonialContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2),
    gap: '15px',
    [theme.breakpoints.up('sm')]: {
      // flexDirection: 'co',
      gap: '25px',
      padding: '0 20px',
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: '35px',
      justifyContent: 'center',
      alignItems: 'baseline',
    },
  },
  testimonialItem: {
    backgroundColor: '#FFF',
    borderRadius: '10px',
    // minHeight: '400px',
    width: '100%',
    height: '100%',
    minHeight: '240px',
    [theme.breakpoints.up('sm')]: {
      // minHeight: '300px',
      maxWidth: '500px',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: '260px',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
    marginBottom: '10px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '20px',
      marginBottom: '20px',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '30px',
      marginBottom: '30px',
    },
  },
  customButton: {
    fontSize: '1.25rem',
    fontWeight: '700',
    fontFamily: 'Lato',
    color: '#FFF',
    backgroundColor: '#2C1482',
    borderRadius: '10px',
    padding: '10px 20px',

  },
}));
